<agr-page-toolbar
  [pageTitle]="getTitle() | async"
  [isEmpty]="!(filteredProprietaryFertilizers$ | async)?.length"
  [emptyTitle]="'proprietary fertilizersEmpty' | translate"
  [emptyDescription]="
    ((filterEnabled$ | async) ? 'noProprietaryFertilizersFound' : 'noProprietaryFertilizers')
      | translate
  "
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  primaryActionText="createProprietaryFertilizer"
  (primaryAction)="createProprietaryFertilizer()"
>
  <div displayAlways class="wrapper--spacing-horizontal layout--margin-top">
    <agr-filter [config]="filterConfig"></agr-filter>
  </div>
  <mat-table mat-table [dataSource]="pagedProprietaryFertilizers$" data-test="crops-table">
    <ng-container matColumnDef="id">
      <mat-header-cell *matHeaderCellDef>{{
        'proprietaryFertilizer.id' | translate
      }}</mat-header-cell>
      <mat-cell *matCellDef="let proprietaryFertilizer">{{ proprietaryFertilizer.id }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef>{{
        'proprietaryFertilizer.name' | translate
      }}</mat-header-cell>
      <mat-cell *matCellDef="let proprietaryFertilizer">{{ proprietaryFertilizer.name }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="nutritionalCompositionN">
      <mat-header-cell *matHeaderCellDef>
        {{ 'nutritionalComposition.n' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let proprietaryFertilizer">
        {{ roundCompositionValue(proprietaryFertilizer.fertilizer.nutritionalComposition.n) }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="nutritionalCompositionP2O5">
      <mat-header-cell *matHeaderCellDef>
        {{ 'nutritionalComposition.p2O5' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let proprietaryFertilizer">
        {{ roundCompositionValue(proprietaryFertilizer.fertilizer.nutritionalComposition.p2O5) }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="nutritionalCompositionK2O">
      <mat-header-cell *matHeaderCellDef>
        {{ 'nutritionalComposition.k2O' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let proprietaryFertilizer">
        {{ roundCompositionValue(proprietaryFertilizer.fertilizer.nutritionalComposition.k2O) }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="productType">
      <mat-header-cell *matHeaderCellDef>{{
        'proprietaryCustomerInformation.originalCropAid' | translate
      }}</mat-header-cell>
      <mat-cell *matCellDef="let proprietaryFertilizer">{{
        getOriginalCropAidName(
          proprietaryFertilizer.fertilizer.proprietaryCustomerInformation?.originalCropAidId
        ) | async
      }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let cropAid" class="flex--justify-end">
        <button
          (click)="editProprietaryFertilizer(cropAid)"
          mat-icon-button
          data-test="proprietary-fertilizers-overview__table__edit"
        >
          <mat-icon>edit</mat-icon>
        </button>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: displayedColumns"
      data-test="proprietary-fertilizers-overview__table__row"
    ></mat-row>
  </mat-table>
  <mat-paginator
    #paginator
    [pageSize]="pageSize"
    [pageSizeOptions]="[10, 25, 50]"
    [length]="(filteredProprietaryFertilizers$ | async)?.length"
    (page)="page($event)"
    showFirstLastButtons
  ></mat-paginator>
</agr-page-toolbar>
